// @ts-nocheck
/* eslint-disable */
export const addIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8333 10.8334H10.8333V15.8334H9.16667V10.8334H4.16667V9.16675H9.16667V4.16675H10.8333V9.16675H15.8333V10.8334Z" fill="currentColor"/></svg>`,
    name: 'add' as const
};